import gql from 'graphql-tag';

const GET_INTEGRATIONS = gql`
  query {
    getIntegrations {
      integrationId
      integrationRefId
      data
      activated
      deletionInProgress
      connectionStatus #ConnectionStatus
    }
  }
`;

const GET_INTEGRATION = gql`
  query($integrationId: ID!) {
    getIntegration(integrationId: $integrationId) {
      integrationId
      data
      activated
      deletionInProgress
      connectionStatus #ConnectionStatus
    }
  }
`;

const GET_INTEGRATIONS_BY_IDS = gql`
  query($integrationIds: [ID]) {
    getIntegrationsByIds(ids: $integrationIds) {
      integrationId
      integrationRefId
      ownLicense
      data
      activated
      deletionInProgress
      connectionStatus #ConnectionStatus
    }
  }
`;

const GET_ADD_ON_DETAILS = gql`
  query($integrationRefId: ID!) {
    getIntegrationAddOns(integrationRefId: $integrationRefId) {
      addOnDetails {
        addOnId
        addOn
        description
        enabled
        billingDetails
        serviceItem {
          itemId
          name
        }
        serviceCatalogItem {
          itemId
          name
        }
      }
      licenseDetails {
        clientCount
        itemCount
      }
    }
  }
`;
// enum ConnectionStatus {
//   CONNECTED,
//   RECONNECT,
//   REAUTHORIZE
// }

const GET_POLICY_INTEGRATION_META = gql`
  query($classId: String, $integrationCategory: String) {
    getPolicyIntegrationSetupMeta(
      classId: $classId
      integrationCategory: $integrationCategory
    )
  }
`;

const INITIATE_REMOTE_SESSTION = gql`
  mutation($assetId: ID!, $integrationType: ID!) {
    initiateRemoteSession(assetId: $assetId, integrationType: $integrationType)
  }
`;

const INITIATE_REMOTE_SESSION_V2 = gql`
  mutation($assetId: ID!, $integrationType: ID!) {
    initiateRemoteSessionV2(
      assetId: $assetId
      integrationType: $integrationType
    ) {
      uri
      retryOptions
    }
  }
`;

// the possible values for name are XERO_SUPEROPS_CLIENT, XERO_SUPEROPS_SERVICE_ITEM, WEBROOT_SITE
const GET_DATA_MAPPING = gql`
  query($name: String!, $page: Int, $pageSize: Int, $listInfo: ListInfoInput) {
    getDataMapping(
      name: $name
      page: $page
      pageSize: $pageSize
      listInfo: $listInfo
    ) {
      mappings {
        source {
          id
          name
          details
        }
        destination {
          id
          name
          details
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
      }
    }
  }
`;

const GET_DATA_MAPPING_V2 = gql`
  query($integrationRefId: ID!, $entityName: String, $listInfo: ListInfoInput) {
    getDataMappingV2(
      integrationRefId: $integrationRefId
      entityName: $entityName
      listInfo: $listInfo
    ) {
      mappings {
        source {
          id
          name
          details
        }
        destination {
          id
          name
          details
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
      }
    }
  }
`;

const GET_DATA_MULTI_MAPPING = gql`
  query($name: String!, $page: Int, $pageSize: Int, $listInfo: ListInfoInput) {
    getDataMapping(
      name: $name
      page: $page
      pageSize: $pageSize
      listInfo: $listInfo
    ) {
      mappings {
        source {
          id
          name
          details
        }
        destinations {
          id
          name
          details
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
      }
    }
  }
`;

const VERIFY_WEBROOT_MAPPING_FOR_ASSET = gql`
  query($assetId: ID!) {
    verifyWebrootMappingForAsset(assetId: $assetId)
  }
`;

const GET_ASSET_THREAT_SUMMARY = gql`
  query($assetId: ID!, $antivirusName: String) {
    getAssetThreatSummary(assetId: $assetId, antivirusName: $antivirusName) {
      activeThreatsCount
      isInfected
      lastScanTime
      threatsRemovedCount
      lastScanCount
    }
  }
`;

const GET_BITDEFENDER_ASSET_THREAT_SUMMARY = gql`
  query($assetId: ID!) {
    getBitDefenderEndpointDetails(assetId: $assetId)
  }
`;
const GET_ASSET_ANTIVIRS_THREAT_SUMMARY = gql`
  query($assetId: ID!) {
    getAssetIntegratedAntivirusDetails(assetId: $assetId) {
      lastScanTime
      nextScanTime
      threatCount
      data
    }
  }
`;

const GET_INTEGRATION_CONFIG_FOR_MAPPED_CLIENTS = gql`
  query($integrationId: ID) {
    getIntegrationConfigForMappedClients(integrationId: $integrationId) {
      accountId
      name
      integrationConfig {
        integrationId
        config
      }
    }
  }
`;

const GET_STRIPE_CUSTOMER_LIST = gql`
  query($listInfo: ListInfoInput) {
    getStripeCustomerList(listInfo: $listInfo) {
      stripeCustomers {
        stripeCustomerId
        name
      }
    }
  }
`;

const SCIM_CONFIGS = gql`
  query($listInfo: ListInfoInput) {
    getAllSCIMConfigurations(listInfo: $listInfo) {
      scimConfigurations {
        accountType
        client {
          name
          accountId
          accountType
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
      }
    }
  }
`;

const LIST_CARDS = gql`
  query($clientId: ID!, $listInfo: ListInfoInput) {
    listCards(clientId: $clientId, listInfo: $listInfo) {
      cards {
        id
        client {
          name
          accountId
        }
        last4Digits
        expiryMonth
        expiryYear
        brand
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
      }
    }
  }
`;

const LIST_ACH_ACCOUNTS = gql`
  query($clientId: ID!) {
    listACHAccounts(clientId: $clientId) {
      id
      routingNumber
      bankName
      isVerified
      last4
    }
  }
`;

const SCIM_TECH_CONFIGS = gql`
  query {
    getCompanySCIMConfiguration {
      url
      authToken
      account {
        accountId
        name
      }
    }
  }
`;

const GET_IM_CONFIGURED_CHANNELS = gql`
  query getIMConfiguredChannels {
    getIMConfiguredChannels {
      privateChannel {
        name
        parentName
        id
      }
      publicChannels {
        name
        parentName
        id
      }
    }
  }
`;

const GET_IM_CHANNELS = gql`
  query getIMChannels($imProvider: String!) {
    getIMChannels(provider: $imProvider) {
      name
      parentName
      id
      channelType
      isConfigured
    }
  }
`;
const GET_IM_CHANNELS_V2 = gql`
  query getIMChannelDetails {
    getIMChannelDetails {
      name
      id
      isConfigured
      channelType
    }
  }
`;

const UPDATE_IM_CHANNEL = gql`
  mutation updateIMChannelMapping($input: IMChannelMappingInput) {
    updateIMChannelMapping(input: $input)
  }
`;

const UPDATE_IM_CHANNEL_V2 = gql`
  mutation updateIMConfig($input: IMConfigInput) {
    updateIMConfig(input: $input)
  }
`;
// type ACHAccount {
//   id: ID!
//   routingNumber: String
//   bankName: String
//   isVerified: Boolean
//   last4: String
// }
const SCIM_CLIENT_CONFIGS = gql`
  query {
    getAllClientSCIMConfigurations {
      url
      authToken
      accountType
      account {
        accountId
        name
      }
    }
  }
`;

const GET_PAYMENT_SETTING = gql`
  query($clientId: ID!) {
    getPaymentSetting(clientId: $clientId) {
      clientId
      autoProcessPayment
      paymentMethodId
      paymentMethod
    }
  }
`;

const GET_CLIENT_PAYMENT_CONFIGURATION = gql`
  query($input: ClientIdentifierInput!) {
    getClientPaymentConfiguration(input: $input) {
      clientId
      autoProcessPayment
      paymentSourceId
      paymentMethod
    }
  }
`;

const CREATE_COMPANY_SCIM = gql`
  mutation createCompanySCIMConfiguration {
    createCompanySCIMConfiguration {
      url
      authToken
      account {
        accountId
        name
      }
    }
  }
`;
const CREATE_CLIENT_SCIM = gql`
  mutation createClientSCIMConfiguration(
    $input: [OrganizationIdentifierInput]!
  ) {
    createClientSCIMConfiguration(input: $input) {
      url
      authToken
      account {
        accountId
        name
      }
    }
  }
`;

const GET_INSTALLATION_PACKAGES_FOR_CLIENT = gql`
  query($clientId: ID) {
    getBitDefenderInstallationPackagesForClient(clientId: $clientId)
  }
`;

const GET_PROTECTION_PLAN_FOR_CLIENT = gql`
  query($clientId: ID) {
    getAcronisProtectionPlansForClient(clientId: $clientId)
  }
`;

const GET_QUICKBOOKS_ACCOUNTS = gql`
  query {
    getQuickBooksAccounts {
      accountId
      name
    }
  }
`;

const GET_XERO_ACCOUNTS = gql`
  query {
    getXeroAccounts {
      accountId
      name
    }
  }
`;

const GET_PAYMENT_METHOD = gql`
  query {
    getPaymentMethods {
      paymentMethodId
      paymentMethodName
    }
  }
`;

// New SCIM Config Queries for Azure Revamp
const GET_COMPANY_SCIM_CONFIGS = gql`
  query($input: ListInfoInput!) {
    getCompanySCIMConfigs(input: $input) {
      configs {
        configId
        url
        authToken
        account {
          accountId
          name
        }
        site {
          id
          name
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_CLIENT_SCIM_CONFIGS = gql`
  query($input: ListInfoInput!) {
    getClientSCIMConfigs(input: $input) {
      configs {
        configId
        url
        authToken
        account {
          accountId
          name
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const CREATE_COMPANY_SCIM_CONFIG = gql`
  mutation($input: CreateCompanySCIMConfigInput!) {
    createCompanySCIMConfig(input: $input) {
      configId
      url
      authToken
      account {
        accountId
        name
      }
      site {
        id
        name
      }
    }
  }
`;

const CREATE_CLIENT_SCIM_CONFIG = gql`
  mutation($input: CreateClientSCIMConfigInput!) {
    createClientSCIMConfig(input: $input) {
      configId
      url
      authToken
      account {
        accountId
        name
      }
    }
  }
`;

const UPDATE_COMPANY_SCIM_CONFIG = gql`
  mutation($input: UpdateCompanySCIMConfigInput!) {
    updateCompanySCIMConfig(input: $input) {
      configId
      url
      authToken
      account {
        accountId
        name
      }
      site {
        id
        name
      }
    }
  }
`;

const UPDATE_CLIENT_SCIM_CONFIG = gql`
  mutation($input: UpdateClientSCIMConfigInput!) {
    updateClientSCIMConfig(input: $input) {
      configId
      url
      authToken
      account {
        accountId
        name
      }
    }
  }
`;

const DELETE_SCIM_CONFIG = gql`
  mutation($input: deleteSCIMConfigIdentifierInput!) {
    deleteSCIMConfig(input: $input)
  }
`;

// Queries for fetching unintegrated clients/sites for SCIM dropdown
const GET_UNINTEGRATED_CLIENT_LIST = gql`
  query($input: GetUnintegratedEntityListInput!) {
    getUnintegratedClientList(input: $input) {
      clients {
        accountId
        name
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_UNINTEGRATED_SITE_LIST = gql`
  query($input: GetUnintegratedEntityListInput!) {
    getUnintegratedSiteList(input: $input) {
      sites {
        id
        name
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

export const FETCH_THIRD_PARTY_ENTITY_LIST = gql`
  query($input: FetchTPEntityListInput!) {
    fetchTPEntityList(input: $input) {
      objects {
        id
        name
        details
      }
      # listInfo {
      #  hasMore
      # }
    }
  }
`;

export const FETCH_THIRD_PARTY_MAPPING_RULE_CONDITION = gql`
  query($input: FetchTPMappingRuleConditionInput!) {
    fetchTPMappingRuleCondition(input: $input) {
      ruleId
      entityType
      conditionAttribute
      conditionValue {
        id
        name
        details
      }
      destination {
        id
        name
        details
      }
    }
  }
`;

const GET_TP_ENTITY_ITEMS = gql`
  query($integrationRefId: ID, $entityName: String) {
    getTPEntityItems(
      integrationRefId: $integrationRefId
      entityName: $entityName
    )
  }
`;

const GET_TP_ENTITY_INSTALLER = gql`
  query($integrationRefId: ID!, $entityName: String, $tpEntityId: String) {
    getTPEntityItems(
      integrationRefId: $integrationRefId
      entityName: $entityName
      tpEntityId: $tpEntityId
    )
  }
`;
const GET_POLICY_INTEGRATION_SETUP_META = gql`
  query($classId: String, $integrationCategory: String) {
    getPolicyIntegrationSetupMeta(
      classId: $classId
      integrationCategory: $integrationCategory
    )
  }
`;

const GET_IM_CONFIG_DETAILS = gql`
  query getIMConfigDetails {
    getIMConfigDetails {
      autoProvisionApp
      provisionedCount
      notProvisionedCount
      provisionAction
      supportedChannelType
    }
  }
`;

export {
  GET_INTEGRATION,
  GET_INTEGRATIONS,
  GET_INTEGRATIONS_BY_IDS,
  INITIATE_REMOTE_SESSTION,
  GET_DATA_MAPPING,
  GET_DATA_MULTI_MAPPING,
  VERIFY_WEBROOT_MAPPING_FOR_ASSET,
  GET_ASSET_THREAT_SUMMARY,
  GET_INTEGRATION_CONFIG_FOR_MAPPED_CLIENTS,
  GET_INSTALLATION_PACKAGES_FOR_CLIENT,
  GET_STRIPE_CUSTOMER_LIST,
  LIST_CARDS,
  GET_PAYMENT_SETTING,
  GET_CLIENT_PAYMENT_CONFIGURATION,
  LIST_ACH_ACCOUNTS,
  SCIM_CONFIGS,
  SCIM_TECH_CONFIGS,
  GET_IM_CHANNELS,
  GET_IM_CONFIGURED_CHANNELS,
  SCIM_CLIENT_CONFIGS,
  GET_PROTECTION_PLAN_FOR_CLIENT,
  GET_BITDEFENDER_ASSET_THREAT_SUMMARY,
  GET_QUICKBOOKS_ACCOUNTS,
  GET_XERO_ACCOUNTS,
  GET_PAYMENT_METHOD,
  GET_ASSET_ANTIVIRS_THREAT_SUMMARY,
  GET_DATA_MAPPING_V2,
  GET_TP_ENTITY_ITEMS,
  INITIATE_REMOTE_SESSION_V2,
  GET_ADD_ON_DETAILS,
  CREATE_COMPANY_SCIM,
  CREATE_CLIENT_SCIM,
  GET_POLICY_INTEGRATION_META,
  GET_TP_ENTITY_INSTALLER,
  UPDATE_IM_CHANNEL,
  GET_POLICY_INTEGRATION_SETUP_META,
  GET_IM_CHANNELS_V2,
  GET_IM_CONFIG_DETAILS,
  UPDATE_IM_CHANNEL_V2,
  // New SCIM Config queries for Azure Revamp
  GET_COMPANY_SCIM_CONFIGS,
  GET_CLIENT_SCIM_CONFIGS,
  CREATE_COMPANY_SCIM_CONFIG,
  CREATE_CLIENT_SCIM_CONFIG,
  UPDATE_COMPANY_SCIM_CONFIG,
  UPDATE_CLIENT_SCIM_CONFIG,
  DELETE_SCIM_CONFIG,
  // Unintegrated entity list queries for SCIM dropdown
  GET_UNINTEGRATED_CLIENT_LIST,
  GET_UNINTEGRATED_SITE_LIST
};
